export async function getThumbnailForVideo(src: string, second = 0) {
  const video = document.createElement('video');
  const canvas = document.createElement('canvas');
  // Hide elements .... TODO: Check if we can delete the next two lines
  video.style.display = 'none';
  canvas.style.display = 'none';
  // Allow anonymous origin
  video.crossOrigin = 'anonymous';
  // Trigger video load
  await new Promise<void>((resolve) => {
    video.addEventListener('loadedmetadata', () => {
      video.currentTime = second;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    });

    video.addEventListener('seeked', () => resolve());
    video.src = src;
  });
  // Draw the thumbnail
  canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
  // Return image
  const imageUrl = canvas.toDataURL('image/png');
  return imageUrl;
}

export default getThumbnailForVideo;
